
import { Vue, Component, Prop } from 'vue-property-decorator'
import { openAccount } from '@/service/authentication'
import { State } from 'vuex-class'

@Component
export default class StepOne extends Vue {
  @Prop({ required: true }) data!: any
  @State bidType!: any

  loading = false
  get cardType() {
    const base: any = {
      '1': '中国居民身份证',
      '2': '护照',
      '3': '港澳居民来往内地通行证（回乡证）',
      '4': '台湾居民来往大陆通行证（台胞证）',
    }
    if (this.bidType === 6) delete base[1]
    return base
  }

  async submit() {
    try {
      await (this.$refs.form as any).validate()
    } catch {
      this.$message.error('请完善必填信息')
      throw new Error('校验失败')
    }

    this.loading = true
    try {
      await openAccount(this.data)
      this.$emit('forward')
    } catch (err) {
      if (err.code === 2001) {
        this.$info({
          title: '温馨提示',
          content: err.msg,
          okText: '知道了',
        })
        this.$emit('forward')
        this.data.mobile = err.data.mobile
        this.data.bindBankSuccess = true
      }
    }
    this.loading = false
  }
}
